import { Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2, HostBinding } from '@angular/core';
import { ClassName, DISMISS_REASONS, NxBaseModalOptions, TransitionDurations } from './nx-base-modal.options';
import { isBs3 } from '../../utils/deps/utils/ng2-bootstrap-config';
import { msConfig } from './nx-base-modalService.config';

@Component({
  selector: 'nx-base-modal-container',
  template: `
  <div [class]="'modal-dialog' + (config.class ? ' ' + config.class : '')" role="document">
  <div class="modal-content"><ng-content></ng-content></div>
</div>`
})
export class NxBaseModalContainerComponent implements OnInit, OnDestroy {
	
  @HostBinding('tabindex') tabindex = -1;
  @HostBinding('role') role = 'dialog';
  @HostBinding('class.modal') modla = true;

  private NxBaseModalService: any;

  public config: NxBaseModalOptions;
  public isShown = false;
  public level: number;
  public isAnimated: boolean;
  protected _element: ElementRef;
  private isModalHiding = false;
  @HostListener('click', ['$event'])
  public onClick(event: any): void {
    if (this.config.ignoreBackdropClick || this.config.backdrop === 'static' || event.target !== this._element.nativeElement) {
      return;
    }
    this.NxBaseModalService.setDismissReason(DISMISS_REASONS.BACKRDOP);
    this.hide();
  }
  @HostListener('window:keydown.esc')
  public onEsc(): void {
    if (this.config.keyboard && this.level === this.NxBaseModalService.getModalsCount()) {
      this.NxBaseModalService.setDismissReason(DISMISS_REASONS.ESC);
      this.hide();
    }
  }

  public constructor(options: NxBaseModalOptions, _element: ElementRef, private _renderer: Renderer2) {
    this.NxBaseModalService = msConfig.serviceInstance;

    this._element = _element;
    this.config = Object.assign({}, options);
  }

  ngOnInit(): void {
    if (this.isAnimated) {
      this._renderer.addClass(this._element.nativeElement, ClassName.FADE);
    }
    this._renderer.setStyle(this._element.nativeElement, 'display', 'block');
    setTimeout(() => {
      this.isShown = true;
      this._renderer.addClass(this._element.nativeElement, isBs3() ? ClassName.IN : ClassName.SHOW);
    }, this.isAnimated ? TransitionDurations.BACKDROP : 0);
    if (document && document.body) {
      if (this.NxBaseModalService.getModalsCount() === 1) {
        this.NxBaseModalService.checkScrollbar();
        this.NxBaseModalService.setScrollbar();
      }
      this._renderer.addClass(document.body, ClassName.OPEN);
    }
  }

  ngOnDestroy(): void {
    if (this.isShown) {
      this.hide();
    }
  }

  hide(): void {
    if (this.isModalHiding || !this.isShown) {
      return;
    }
    this.isModalHiding = true;
    this._renderer.removeClass(this._element.nativeElement, isBs3() ? ClassName.IN : ClassName.SHOW);

    setTimeout(() => {
      this.isShown = false;
      if (document && document.body && this.NxBaseModalService.getModalsCount() === 1) {
        this._renderer.removeClass(document.body, ClassName.OPEN);
      }
      this.NxBaseModalService.hide(this.level);
      this.isModalHiding = false;
    }, this.isAnimated ? TransitionDurations.MODAL : 0);
  }
}
